import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  return {
    root: {
      '& .rankingList': {
        marginBlockEnd: 0,
        marginBlockStart: 0,
        paddingInlineStart: pxToRem(18),
        [theme.breakpoints.down('md')]: {
          fontSize: pxToRem(12),
        },
        '& li': {
          fontSize: pxToRem(14),
          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(12),
          },
        }
      }
    },
    questionLabel: {
      fontSize: pxToRem(14),
      lineHeight: 'normal',
      letterSpacing: 0,
      fontFamily: theme.custom.fontFamily.primaryBold,
      marginBottom: pxToRem(10),
      '& .MuiRating-icon': {
        '& .MuiSvgIcon-root': {
          width: pxToRem(13),
          height: pxToRem(13)
        }
      },
      [theme.breakpoints.down('md')]: {
        fontSize: pxToRem(12),
      }
    },
  };
});
export default useStyles;
